import React, { useState } from "react";
import { images } from "../Helper/Carouseldata";
import "./Home.css";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

function Home() {
  const [currimg,setcurrimg] = useState(0);
  

  return (
    <div className="home">
      <div
        className="left"
        onClick={() => {
          currimg > 0 && setcurrimg(currimg - 1);
        }}
      >
        <ArrowBackIosIcon />
      </div>
      <div
        className="carousel"
        style={{ backgroundImage: `url(${images[currimg].img})` }}
      >
        <div className="center"></div>
      </div>
      <div
        className="right"
        onClick={() => {
          currimg < images.length - 1 && setcurrimg(currimg + 1);
        }}
      >
        <ArrowForwardIosIcon />
      </div>
    </div>
  );
}

export default Home;
